import type { AnalyticsContext } from './analytics.types';

const LOG_PREFIX = '[Analytics]';

// Access __RUNTIME_CONFIG__ without a global Window augmentation so this lib
// does not conflict with app-level RuntimeConfig declarations (e.g. periverse).
type RuntimeConfigWindow = Window & { __RUNTIME_CONFIG__?: Record<string, string | undefined> };
const rc = (): Record<string, string | undefined> | undefined =>
  (window as RuntimeConfigWindow).__RUNTIME_CONFIG__;

function getRuntimeVar(key: string, fallback = ''): string {
  const value = rc()?.[key];
  if (value && value !== `\${${key}}` && value.trim() !== '') {
    return value;
  }

  if (!value) {
    console.warn(
      `%c${LOG_PREFIX} getRuntimeVar — "${key}" not found in __RUNTIME_CONFIG__, using fallback: "${fallback}"`,
      'color: #FF9800'
    );
  }

  return fallback;
}

export function getAnalyticsConfig(appName: string, hospital?: string): AnalyticsContext {
  const config: AnalyticsContext = {
    gtmContainerId: getRuntimeVar('VITE_GTM_CONTAINER_ID'),
    ga4MeasurementId: getRuntimeVar('VITE_GA4_MEASUREMENT_ID'),
    environment: getRuntimeVar('VITE_DEV_MODE', 'false') === 'true' ? 'development' : 'production',
    appName,
    hospital: hospital ?? getRuntimeVar('VITE_SITE_ID', appName),
    tenantName: getRuntimeVar('VITE_TENANT_ID', ''),
  };

  return config;
}
